// extracted by mini-css-extract-plugin
export default {"ctn":"App_ctn__s9+oB","description":"App_description__CzAHm","quantity":"App_quantity__6tFkf","buttonGroup":"App_buttonGroup__YPx0-","buttonCta":"App_buttonCta__PDHia"};